import Decorator from "./Decorator";

export default Decorator;
